import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetApiKeySettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetAPIKeySettingsAttempt', handleGetApiKeySettings, api);
}

function* handleGetApiKeySettings(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingGetAPIKeySettingsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getApiKeySettings], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetAPIKeySettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetAPIKeySettingsSuccess(response.data));
    }
}
